export enum TeamRaceType {
    RELAY = 1,
    CONCURRENT = 2,
}